import React, { useEffect, useState } from "react";

export default function CustomCursor() {
  const [pos, setPos] = useState({ x: -100, y: -100 });
  const [hovering, setHovering] = useState(false);

  useEffect(() => {
    const onMove = (e: MouseEvent) => setPos({ x: e.clientX, y: e.clientY });

    const onOver = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const isClickable =
        target.closest("a, button, [role=button], input, textarea, select");
      setHovering(!!isClickable);
    };

    document.addEventListener("mousemove", onMove);
    document.addEventListener("mouseover", onOver);

    // Hide default cursor
    document.body.style.cursor = "none";

    return () => {
      document.removeEventListener("mousemove", onMove);
      document.removeEventListener("mouseover", onOver);
      document.body.style.cursor = "";
    };
  }, []);

  // Hide on touch devices
  if (typeof window !== "undefined" && "ontouchstart" in window) return null;

  return (
    <>
      {/* Outer ring — smooth follower */}
      <div
        className="pointer-events-none fixed z-[9999] hidden transition-all duration-150 ease-out tablet:block"
        style={{
          left: pos.x - 18,
          top: pos.y - 18,
          width: 36,
          height: 36,
          borderRadius: "50%",
          border: "1px solid rgba(212,255,0,0.3)",
          opacity: hovering ? 0.6 : 0.4,
          transform: hovering ? "scale(1.4)" : "scale(1)",
        }}
      />
      {/* Inner dot */}
      <div
        className="pointer-events-none fixed z-[9999] hidden tablet:block"
        style={{
          left: pos.x - 3,
          top: pos.y - 3,
          width: 6,
          height: 6,
          borderRadius: "50%",
          background: "#D4FF00",
          boxShadow: "0 0 8px rgba(212,255,0,0.5), 0 0 20px rgba(212,255,0,0.15)",
        }}
      />
    </>
  );
}
